import React from "react";
import { Modal, Button } from "@cloudscape-design/components";
import "./ActionPlanModal.css";

const ConfirmActionPlanModal = ({
  visible,
  title,
  message,
  confirmLabel = "Confirm",
  submitting = false,
  onConfirm,
  onDismiss,
}) => {
  if (!visible) return null;

  return (
    <Modal
      visible={visible}
      header={title || "Confirm action"}
      size="medium"
      onDismiss={submitting ? null : onDismiss}
      closeAriaLabel="Dismiss confirmation dialog"
      footer={
        <div className="intervention-modal-footer">
          <Button className="intervention-modal-dismiss" onClick={onDismiss} disabled={submitting}>
            Cancel
          </Button>
          <Button variant="primary" onClick={submitting ? undefined : onConfirm} loading={submitting} disabled={submitting}>
            {confirmLabel}
          </Button>
        </div>
      }
    >
      <div className="action-plan-confirmation">
        {message || "Are you sure you want to continue?"}
      </div>
    </Modal>
  );
};

export default ConfirmActionPlanModal;
